import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem('iwx_access_token');
    if (!token) {
      setLoading(false);
      return;
    }
    try {
      const { data } = await authAPI.me();
      setUser(data);
    } catch {
      localStorage.removeItem('iwx_access_token');
      localStorage.removeItem('iwx_refresh_token');
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadUser();
  }, [loadUser]);

  const login = async (credentials) => {
    const { data } = await authAPI.login(credentials);
    localStorage.setItem('iwx_access_token', data.access_token);
    localStorage.setItem('iwx_refresh_token', data.refresh_token);
    setUser(data.user);
    return data;
  };

  const register = async (userData) => {
    const { data } = await authAPI.register(userData);
    localStorage.setItem('iwx_access_token', data.access_token);
    localStorage.setItem('iwx_refresh_token', data.refresh_token);
    setUser(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('iwx_access_token');
    localStorage.removeItem('iwx_refresh_token');
    setUser(null);
  };

  const isAdmin = user?.role === 'admin';
  const isEditor = ['admin', 'manager', 'editor'].includes(user?.role);

  return (
    <AuthContext.Provider
      value={{ user, loading, login, register, logout, isAdmin, isEditor, loadUser }}
    >
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error('useAuth must be used within AuthProvider');
  return ctx;
}
